import { render, staticRenderFns } from "./Bim.vue?vue&type=template&id=da017254&scoped=true"
import script from "./Bim.vue?vue&type=script&lang=js"
export * from "./Bim.vue?vue&type=script&lang=js"
import style0 from "./Bim.vue?vue&type=style&index=0&id=da017254&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da017254",
  null
  
)

export default component.exports